import type { RootState } from 'features/app/store/store';
import { removeAnyLeadingNonNumbers } from 'features/call/call-base/helpers';
import { isHearingCallerIdBlockedSelector } from 'features/call/call-base/store/selectors';
import { deafPhoneNumberSelector } from 'features/call/call-deaf/store';
import { primaryHearingPhoneNumberSelector } from 'features/call/call-hearing/store';
import { ANONYMOUS } from 'features/voice-meeting/constants';
import { isStringAllLettersOrEmpty } from 'common/helpers';

/**
 * Builds the Core request used by SignMail flows that need deaf-user metadata.
 *
 * Flow notes:
 * - The deaf phone number becomes the callee being resolved.
 * - The active hearing number becomes the caller when it is numeric.
 * - Anonymous or non-numeric caller IDs are normalized to the Core sentinel so
 *   greeting resolution and AST routing use the same fallback contract.
 */
export const getDeafUserInformationRequest = (state: RootState) => {
  const deafPhoneNumber = deafPhoneNumberSelector(state);
  const isHearingCallerIdBlocked = isHearingCallerIdBlockedSelector(state);

  let hearingNumberToResolveWithCore = removeAnyLeadingNonNumbers(
    primaryHearingPhoneNumberSelector(state)
  );

  if (isStringAllLettersOrEmpty(hearingNumberToResolveWithCore)) {
    hearingNumberToResolveWithCore = ANONYMOUS;
  }

  return {
    calleeNumber: deafPhoneNumber,
    callerNumber: hearingNumberToResolveWithCore,
    blockCallerId: isHearingCallerIdBlocked,
  };
};
